export function htmlToPlainText(html) {
    if (!html) return "";

    if (!/[<>]/.test(html)) return String(html);

    const doc = new DOMParser().parseFromString(String(html), "text/html");
    return (doc.body.textContent || "").replace(/\u00A0/g, " ").trim();
}
